module.exports = __webpack_public_path__ + "static/img/p_13.2e921c3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/order/p_13.jpg
// module id = rGWG
// module chunks = 9